import { ArrowsLeftRightIcon, CardsThreeIcon, UsersIcon, WalletIcon } from "@phosphor-icons/react";
import StatsCard from "components/BasicStatsCard";
import SidebarLayout from "components/Layout/Layout";
import ActiveTradingAccountList from "pages/Dasboard/MainDashBoard/component/AccountTable";
import TransactionHistory from "pages/Dasboard/MainDashBoard/component/TransactionHistory";

const TransactionMainPage = () => {

    return (
        <SidebarLayout
            title={
                (
                    <h4 className="text-2xl font-bold !m-0 py-4">
                        Transaction Dashboard
                    </h4>
                )
            }
        >
            <div className="grid lg:!grid-cols-4 grid-cols-1 gap-4 w-full ">
                <StatsCard
                    title="Total Accounts"
                    icons={<CardsThreeIcon size={24} />}
                    value={150}
                    iconBackgroundColor="#f0f0f0"
                />
                <StatsCard
                    title="Active Users"
                    icons={<UsersIcon size={24} />}
                    value={120}
                    iconBackgroundColor="#f0f0f0"
                />
                <StatsCard
                    title="Total Balance"
                    icons={<WalletIcon size={24} />}
                    value={50000}
                    iconBackgroundColor="#f0f0f0"
                />
                <StatsCard
                    title="Total Trades"
                    icons={<ArrowsLeftRightIcon size={24} />}
                    value={300}
                    iconBackgroundColor="#f0f0f0"
                />
            </div>
            <div className="mt-6">
                <TransactionHistory
                    option={{
                        title: true,
                        table: true,
                        filter: true,
                        pagination: true,
                        randomize: true,
                        randomizeInterval: 1000,
                        border: false,
                        padding: {
                            top: '20px',
                            bottom: '20px',
                            left: '0px',
                            right: '0px'
                        },
                        shadow: true
                    }}
                />
            </div>
        </SidebarLayout>
    );
}
export default TransactionMainPage;